export default "__VITE_ASSET__62f9f72d__"